// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// THIS FILE WAS AUTOGENERATED
import { Base } from './Base';
/**
 * Data struct to contain both B and C sections.
 */
var Data = /** @class */ (function (_super) {
    __extends(Data, _super);
    function Data() {
        return _super.call(this) || this;
    }
    return Data;
}(Base));
export { Data };
//# sourceMappingURL=Data.js.map